module.exports = __webpack_public_path__ + "images/blank-fc94fb0c3ed8a8f909dbc7630a0987ff.gif";